import React, { useState } from 'react';
import styles from './orderItemDetail.module.scss';
import cn from 'classnames';

const TabComponent = (props) => {
  const [selected, setSelected] = useState(0);
  const setTab = (index) => {
    setSelected(index);
  };

  const renderContent = () => {
    return (
      <div className={cn('tabs__content h-67')} style={{ overflow: 'hidden' }}>
        {props.children[selected]}
      </div>
    );
  };

  const renderLabels = () => {
    return props.children.filter((child) => child !== null).map((child, index) => (
      <div key={child.props.label} role="presentation" onClick={() => { setTab(index); }} 
        className={cn(props.children.filter((e) => e !== null).length > 1 ? 'col-6' : 'col-12 rounded', 'd-flex justify-content-center align-items-center fs_16', index === selected ? index === 0 ? "rounded-left" : "rounded-right" : '', index === selected && cn(styles.selected_tab, 'fw-500') )}
        style={{background: index === selected ? props?.serverAppTheme?.selected : props?.serverAppTheme?.popUp_bg}}>
        {child.props.label}
      </div>
    ));
  };

  return (
    <div className={cn('tabs h-100 fs_12 p-3')} style={{color: props?.serverAppTheme?.primary_text}}>
      <div className={cn(styles.tabStyle, 'row p-0 col-12 mx-0 h-10 mb-3 rounded')} style={{border: `1px solid ${props?.serverAppTheme?.itemFacts}`}}>
        {renderLabels()}
      </div>
      {renderContent()}
    </div>
  );
};

export default TabComponent;
